import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { StoreModule } from '@ngrx/store';

import * as fromOpenTripPlanner from './+state/open-trip-planner.reducer';
import { OpenTripPlannerEffects } from './+state/open-trip-planner.effects';
import { OpenTripPlannerFacade } from './+state/open-trip-planner.facade';
import { OpenTripPlannerService } from './open-trip-planner.service';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature(fromOpenTripPlanner.FEATURE_KEY, fromOpenTripPlanner.openTripPlannerReducer)
    ],
    providers: [OpenTripPlannerFacade, OpenTripPlannerService, OpenTripPlannerEffects]
})
export class OpenTripPlannerModule {}
